// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.osln-tab-container {
  border-radius: 8px;
  font-family: "Qualcomm Next", "Helvetica Neue", Helvetica, Arial, sans-serif;
  background-color: transparent;
  color: rgba(0, 0, 0, 0.85);
}

table {
  width: 100%;
  border-collapse: collapse;
  border: none;
  margin-bottom: 20px;
  line-height: 1.5715;
  font-family: "Arial Regular", "Helvetica Neue", Helvetica, sans-serif;
}

tr {
  display: table-row;
}

td {
  padding: 10px;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.3s;
}

th {
  padding: 10px;
  text-align: left;
  color: rgba(0, 0, 0, 0.85);
  background: #fafafa;
  /*border-bottom: 1px solid #f0f0f0;*/
  border-bottom: 1px solid #ccc;
}

table tr:hover {
  background-color: #fafafa;
}

.solutions-table .clickable {
  color: rgb(50, 83, 220);
  cursor: pointer;
}

.change-state-button {
  background-color: blue;
  color: white;
  padding: 5px 10px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
}

.change-state-button:hover {
  background-color: #5a7ce8;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  backdrop-filter: blur(5px); /* Blur effect */
  z-index: 999; /* Ensure it is on top of other elements */
}

.details-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  width: 70%;
  padding: 20px;
  z-index: 1000; /* Ensure it is above the overlay */
}

.popup-content {
  background: white;
  border-radius: 8px;
  width: 100%;
}


.close-popup-button {
  margin-top: 1.5rem;
  background: grey;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  float: right;;
}`, "",{"version":3,"sources":["webpack://./src/components/assets/OnboardedSolutionDetails.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,4EAA4E;EAC5E,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qEAAqE;AACvE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,gCAAgC;EAChE,0BAA0B,EAAE,gBAAgB;EAC5C,YAAY,EAAE,0CAA0C;AAC1D;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,aAAa,EAAE,mCAAmC;AACpD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd","sourcesContent":[".osln-tab-container {\n  border-radius: 8px;\n  font-family: \"Qualcomm Next\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  background-color: transparent;\n  color: rgba(0, 0, 0, 0.85);\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  border: none;\n  margin-bottom: 20px;\n  line-height: 1.5715;\n  font-family: \"Arial Regular\", \"Helvetica Neue\", Helvetica, sans-serif;\n}\n\ntr {\n  display: table-row;\n}\n\ntd {\n  padding: 10px;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.85);\n  border-bottom: 1px solid #f0f0f0;\n  transition: background 0.3s;\n}\n\nth {\n  padding: 10px;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.85);\n  background: #fafafa;\n  /*border-bottom: 1px solid #f0f0f0;*/\n  border-bottom: 1px solid #ccc;\n}\n\ntable tr:hover {\n  background-color: #fafafa;\n}\n\n.solutions-table .clickable {\n  color: rgb(50, 83, 220);\n  cursor: pointer;\n}\n\n.change-state-button {\n  background-color: blue;\n  color: white;\n  padding: 5px 10px;\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.change-state-button:hover {\n  background-color: #5a7ce8;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n  backdrop-filter: blur(5px); /* Blur effect */\n  z-index: 999; /* Ensure it is on top of other elements */\n}\n\n.details-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  width: 70%;\n  padding: 20px;\n  z-index: 1000; /* Ensure it is above the overlay */\n}\n\n.popup-content {\n  background: white;\n  border-radius: 8px;\n  width: 100%;\n}\n\n\n.close-popup-button {\n  margin-top: 1.5rem;\n  background: grey;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  float: right;;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
